// extracted by mini-css-extract-plugin
module.exports = {"tertiaryBtnCustomStyle":"styles_tertiaryBtnCustomStyle__otiDn","textualElement":"styles_textualElement__4cGu9"};